export type PlanType = 'magic' | 'trial' | 'cosmic';

export interface UserProfile {
  id: string;
  email: string;
  plan: PlanType;
  prompt_count_daily: number;
  prompt_count_total: number;
  trial_started_at: string | null;
  trial_expires_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface PlanAccess {
  isMagic: boolean;
  isTrial: boolean;
  isCosmic: boolean;
  dailyPromptLimit: number;
}

export function getPlanAccess(profile: UserProfile | null): PlanAccess {
  if (!profile) {
    return {
      isMagic: true,
      isTrial: false,
      isCosmic: false,
      dailyPromptLimit: 5
    };
  }

  const plan = profile.plan;
  
  return {
    isMagic: plan === 'magic',
    isTrial: plan === 'trial',
    isCosmic: plan === 'cosmic',
    dailyPromptLimit: plan === 'magic' ? 5 : plan === 'trial' ? 35 : Infinity
  };
}